import $api from "../http";
import { ILoyaltyHistory, ILoyaltySettings, ILoyaltySettingsUpdate } from "../models/Loyalty";

class LoyaltyServiceClass {
  async getLoyaltySettings() {
    return $api.get<ILoyaltySettings>(`api/loyalty-settings`);
  }

  async updateLoyaltySettings(model: ILoyaltySettingsUpdate) {
    return $api.put<{}>(`api/loyalty-settings`, model);
  }

  async getLoyaltyHistory(
    userId: string | null,
    limit: number | undefined,
    skip: number | undefined
  ) {
    let queryString = "?";
    if (userId) {
      queryString += `&userId=${userId}`;
    }
    if (limit) {
      queryString += `&limit=${limit}`;
    }
    if (skip) {
      queryString += `&skip=${skip}`;
    }
    return $api.get<{ historyItemsLength: number; historyItems: ILoyaltyHistory[] }>(
      `api/loyalty-history${queryString}`
    );
  }

  async getUserBalanceByUserId(userId: string) {
    return $api.get<{
      userId: string;
      loyaltyPointsBalance: number;
      earliestExpireDate: null | Date;
      earliestExpirePoints: number | null;
    }>(`api/loyalty-history/user-balance/${userId}`);
  }
}

export const LoyaltyService = new LoyaltyServiceClass();
